import { Container, ContainerGutter } from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaDisclaimerTextLegal } from '../ui/hucha-disclaimer-text-legal';

interface DisclaimerContentProps {
	fontSize?: string;
	showDisclaimerNumber?: boolean;
	textGutter?: ContainerGutter;
}

export const HuchaDisclaimer1Content = ({
	fontSize,
	showDisclaimerNumber = true,
	textGutter = ContainerGutter.static350,
}: DisclaimerContentProps): React.JSX.Element => {
	return (
		<Container wrap={'always'} gutter={textGutter}>
			<HuchaDisclaimerTextLegal fontSize={fontSize}>
				{showDisclaimerNumber && '1. '}
				El importe acumulado en “Tu hucha Volkswagen” podrá ser aplicado como descuento por parte de los miembros del
				Club Volkswagen particulares que deseen adquirir un vehículo nuevo (aplicable a toda la gama Volkswagen de stock
				y pedidos a producción) antes del 31/12/2026 en la Red de Concesionarios Oficiales de la marca Volkswagen. No
				canjeable para la compra de otros productos y/o servicios (por ejemplo, accesorios o servicios posventa, etc.).
				El saldo acumulado en la hucha Volkswagen no podrá canjearse nunca por dinero en metálico.
			</HuchaDisclaimerTextLegal>
			<HuchaDisclaimerTextLegal fontSize={fontSize}>
				Descuento disponible únicamente para el miembro del Club Volkswagen que se descargue este cupón desde su portal
				de cliente. Se aceptará un único cupón por compra y será válido una única vez. Acumulativo a otras promociones
				de la marca excepto: Promociones Selectivas Web. El cupón no será acumulable a ofertas ya realizadas por parte
				del concesionario ni para pedidos ya realizados, ni cancelados.
			</HuchaDisclaimerTextLegal>
		</Container>
	);
};
